import { Component, OnInit, Input, ElementRef, Renderer, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml} from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { steppedFlyX, flyIn, overlay, expandablepoint } from './item.animations';
import { animateOpen, rotateOpen } from '../animations';
import { flyInOut, fadeIn, fade, featureslist, zFade, Cart, ShareMenu, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, featuresBox } from '../animations';
import { Observable } from 'rxjs/Rx';
import { Filter } from '../../models/filter.constructor';

import { environment } from '../../environment';
import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';
import { Category } from '../../models/category';
import { Statistic } from '../../models/statistics';
import { Product } from '../../models/product';
import { Item } from '../../models/item';
import { Currency } from '../../models/currency';
import { Img } from '../../models/image';

declare var $: any;
declare var MasterSlider: any

@Component({
  selector: 'item',
  templateUrl: './item.component.html',
  providers: [ StoreService, UserService ],
  animations: [ expandablepoint, steppedFlyX, overlay, flyIn, flyInOut, fadeIn, animateOpen, rotateOpen, featuresBox, featureslist, fade, zFade, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, ShareMenu ]
})

export class ItemComponent implements OnInit {

	@ViewChild('shareLink') shareLink:ElementRef;
	@Input() resetCart = false;

	loading = true;
	items: Item;
	selectedItem: Item;
	purchased: Item;
	features: Item;
	
	query = new Filter();
  	currency:   Currency;
	currencies: Currency;
	categories: Category;
	cartItems: Product;
	products: Product;

	listingInCart: boolean;
	numberOfProducts: any;
	productName: string;
	custom: any;
	pointOpen: number;
	customizer: any[];
	cart: any[];
	total: number;
	itemtotal: number;
	viewItem: number;
	translateImage: any;
	windowLink: string;
	
	x = 0; // Pagation variable
	y = 0; // 

	showImage = 0; 
	showModel = 0; 
	itemImages = 0;
	LightboxImage = "";

	showItemDetails = false;
	showFeatures = false;
	hideFeatured = false;
	flashCart = false;
	currencyOpen = false;
	displayModel = false;
	ShowPointbox = false;

	stockNotice = true;
	limitNotice = true;
	betaNotice = true;
	buildStatus = true;
	purchaseButton = true;
	requirementsNotice = false;
	enableCurrencySelector = false;

	ShowLightbox: any;
	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	subtitleLink: string;
	subtitleIcon: string;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router,
				private element: ElementRef,
  				private renderer: Renderer) {
	}


	/**
	* Images and Lightbox
	**/

	openLightbox(i) {
		this.ShowLightbox = this.ShowLightbox ? false : true;
	}


	pickImage(index) {
		this.showImage = index;
	}

	// swipeImage(action = 'swipeleft', imageslength) {
	//        if (action === 'swipeleft') {
	//        	this.showImage = (this.showImage < imageslength-1) ? this.showImage+1 : this.showImage;
	//        }
	//        if (action === 'swiperight') {
	//        	this.showImage = (this.showImage > 0) ? this.showImage-1  : this.showImage;
	//        }
	//    }

    swipeImage(action = 'swipeleft', imageslength) {
        if (action === 'swipeleft'){
        	this.showImage = (this.showImage < imageslength-1) ? this.showImage+1 : this.showImage;
        }
        if (action === 'swiperight'){
        	this.showImage = (this.showImage > 0) ? this.showImage-1  : this.showImage;
        }
    }

	/* 
	* Products that may be featured
	*/
	getProduct() {	

		// Product pagation
	 	this.y = 0;
		this.query.ids = this.route.snapshot.params['id'];

		Promise.resolve(this.storeService.getItems(this.query)).then((productData) => {

			this.items = productData;

			if ( this.items[0] && this.items[0].published ) {

				this.purchaseButton = ( this.items[0].hidden == 1 ) ? false : true;
				this.productName = this.items[0].title;
				this.title = this.productName;
				let pageTitle = this.productName + ' | Identity RPG';
				//let pageImage = this.items[0].images[0].url;
				
				if ( this.items[0].category_info[0] ) {
					this.subtitle = this.items[0].category_info[0].name;
					this.subtitleLink = '/shop/categories/'+this.items[0].category_info[0].id;
					this.subtitleIcon = this.items[0].category_info[0].icon;
				}

				setTimeout( () => { this.loading = false; }, 100);

			} else {
				window.location.pathname = '/items';
			}

		});

		// Products that include item
		Promise.resolve(this.storeService.loadProductsWithItem(this.viewItem)).then( (featuredProducts) => {
			this.products = featuredProducts;
		});

		Promise.resolve(this.storeService.numberOfProductsWithItem(this.viewItem)).then( (count) => {
			this.numberOfProducts = count;
		});

	}

	addToCart( item ) {
		if ( item.limit == 0 || item.limit > item.owns ) {
			if ( this.inCart(item.id) ) {
				this.router.navigate(['/checkout']);
			} else {
				this.storeService.addItem(item.id);
				this.selectedItem = item;
				this.getCart();
				this.updateCartButton();
			}
		}
	}

	inCart(id) {
		this.listingInCart = ( this.custom.indexOf( id ) > -1 ) ? true : false;
		return this.listingInCart;
	}


	getCart() {
		this.cart = this.storeService.getCartContents();
		this.custom = this.storeService.getItemContents();
	}




	getTotal() {
		Promise.resolve(this.storeService.getCartTotal()).then(cartTotal => 
			this.total = cartTotal
		);
	}



	inStock(listing) {
		if ( listing.stock > 0 || listing.stock == '-1' )
			return true;
	}

	subtractQuantity(item) {
		if( this.selectedItem.id == item.id && this.selectedItem.quantity > 0)
			this.selectedItem.quantity--;
		this.storeService.removeItem(item.id);
		this.getCart();
	}



	removeFromCart(itemIndex) {
		this.storeService.removeItem(itemIndex);
		this.getCart();
	}


	inAccount( listingidentifier ) {
		Promise.resolve( this.storeService.countItemsInAccount( listingidentifier ) ).then((accountCount) => {
			return accountCount;
		});
	}

	openPoint(i) {
		this.ShowPointbox = true;
		this.pointOpen = i;
	}

	closePoint() {
		this.ShowPointbox = false;
		setTimeout( () => { this.pointOpen = 0; }, 50);
	}

	/**
	* Currencies
	**/

	getCurrencies() {
		if ( environment.currencies ) {
			Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
				this.currencies = c;
			});

			Promise.resolve( this.storeService.getCurrency() ).then((c) => {
				this.currency = c[0];
			});

			Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
				this.enableCurrencySelector = bool;
			});
		}
	}

	changeCurrency(currency) {
		this.currency = currency;
		this.currencyOpen = false;
		this.storeService.changeCurrency(currency);
	}




	/**
	* Currencies
	**/

	imageMove(e, image) {
		let imageHeight = e.srcElement.clientHeight;
		let divHeight = e.srcElement.parentNode.clientHeight;
		if( imageHeight > divHeight) {
			let x = e.layerX, y = e.layerY;
			// e.srcElement.parentNode.scrollTop( imageHeight / ( y/divHeight*100 ) )
			// this.translateImage = this.sanitizer.bypassSecurityTrustStyle('translateY(-'++'%');
		}

	}






	/**
	* Share Menu
	**/

	focusLink() {
		this.shareLink.nativeElement.focus();
	}

	doShare(service) {

		//
		let url = environment.baseUrl+'/item/'+this.items[0].id;

		// Meta details for sharing
		let title = 'Identity RPG - '+this.items[0].title+' - '+this.items[0].description;

		switch (service) {
			case "facebook":
				var fbbase = 'https://www.facebook.com/sharer.php?u=';
				var fbs = fbbase + url + '&t=' + title;
				this.openWindow('265', '640', 'Share Identity on Facebook', fbs);
			break;
			case "twitter":
				var twbase = 'https://twitter.com/share?url=';
				var tws = twbase + url + '&text=' + title;
				this.openWindow('289', '624', 'Tweet about Identity', tws);
			break;
			case "google":
				var tmbase = 'https://plus.google.com/share?url='+url+'&name="Identity RPG - '+this.items[0].title+'"';
				this.openWindow('590', '400', 'Share Identity on Google Plus', tmbase);
			break;
			case "tumblr":
				var tmbase = 'https://plus.google.com/share?url='+url+'&name=Identity RPG - '+this.items[0].title+'&description='+this.items[0].description;
				this.openWindow('289', '624', 'Share Identity on Tumblr', tmbase);
			break;
			case "email":
				window.location.href = "mailto:address@gmail.com";
			break;
			default:

			break;
		}

	}

	openWindow(windowHeight, windowWidth, windowName, windowUri) {

		var centerWidth = (window.screen.width / 2) - windowWidth;
		var centerHeight = (window.screen.height / 2) - windowHeight;

		let newWindow = window.open(windowUri, windowName, 'resizable=0,width=' + windowWidth + 
			',height=' + windowHeight + 
			',left=' + centerWidth + 
			',top=' + centerHeight);

		newWindow.focus();
		return newWindow.name;
	}


	updateCartButton() {
	 	this.flashCart = true;
	 	setTimeout( () => { this.flashCart = false;  }, 5000);
	}

	/** On with the show **/
	ngOnInit() 
	{

		/**
		* Get Details for this particular Item
		* Accept URL Parameter /:id
		**/
		this.router.events
		.filter(event => event instanceof NavigationEnd)
		.map(() => this.router.routerState.root)
		.subscribe((event) => {
			this.viewItem = this.route.snapshot.params['id'];
			this.getProduct();
		});

		this.viewItem = this.route.snapshot.params['id'];
		this.windowLink =  window.location.href;
		this.getProduct();
		this.getCart();

		Promise.resolve(this.storeService.getItems()).then( (featuredItems) => {
			this.features = featuredItems;
		});

		Promise.resolve(this.storeService.getCategories()).then((categories) => {
			this.categories = categories;
		});

		this.getCurrencies();
		// Identity Header
		this.title = this.productName;
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/concept/club2.jpeg") 0px 47%' );
		this.subtitle = 'Exclusive Identity game item.';
		this.headerHeight = '300px';

	}

  	// 	Setup Masterslider for 
  	//	#ProductImages
	ngAfterViewInit() {

		$("#ItemImages").fancy_scroll({
			innerWrapper: "ul.main"
		});

		// var slider = new MasterSlider();
		// slider.setup('ProductImages' , {
		// 	width: 1140,
		// 	view:"flow",
		// 	fullwidth:true,
		// 	height: 300,
		// 	loop: true,
		// 	autoplay: true,
		// 	keyboard: true,
		// 	speed: 10,
		// 	instantStartLayers: true,
		// 	filters: {
		// 		opacity: 0.7,
		// 		brightness: 2
		// 	}
		// });
	}

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/item/item.component.ts